/**
 * Public PostHog embeds for “Flitrip — Vista Andrea” (EU project 251068).
 * PostHog shared dashboards have a fixed date range, so each preset is a copy
 * of dashboard 1017510 that shares its insights and only overrides the dates.
 */
export const POSTHOG_DEVICE_STATS_EMBED_URLS = {
  // dashboard 1067733
  last7Days: "https://eu.posthog.com/embedded/mE1jKygEhH_mOsfFgzsTmMCyOnxqlw",
  // dashboard 1017510
  last30Days: "https://eu.posthog.com/embedded/bagl126PjuLr7l0yXOTZjySb8Zr2Xw",
  // dashboard 1067735
  last90Days: "https://eu.posthog.com/embedded/iZzrDn8qRNyDKipC4N7s99xWJmoBMg",
  // dashboard 1067736
  thisMonth: "https://eu.posthog.com/embedded/HdnCyfip7h2XXwgUAX-_BxEIRWCyhg",
  // dashboard 1067737
  lastMonth: "https://eu.posthog.com/embedded/HPfRWhq_c2xaFAAFVIrB151-mONSlg",
} as const;

export type DeviceStatsRange = keyof typeof POSTHOG_DEVICE_STATS_EMBED_URLS;

export const DEVICE_STATS_RANGES = Object.keys(
  POSTHOG_DEVICE_STATS_EMBED_URLS,
) as DeviceStatsRange[];

export const DEFAULT_DEVICE_STATS_RANGE: DeviceStatsRange = "last30Days";

export const POSTHOG_DEVICE_STATS_IFRAME_NAME = "FlitripDeviceStats";
